import { render, staticRenderFns } from "./miningRecord.vue?vue&type=template&id=e478e454&scoped=true&"
import script from "./miningRecord.vue?vue&type=script&lang=js&"
export * from "./miningRecord.vue?vue&type=script&lang=js&"
import style0 from "./miningRecord.vue?vue&type=style&index=0&id=e478e454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e478e454",
  null
  
)

export default component.exports